import { render, staticRenderFns } from "./BubbleGame.vue?vue&type=template&id=bfab8a12&scoped=true"
import script from "./BubbleGame.vue?vue&type=script&lang=js"
export * from "./BubbleGame.vue?vue&type=script&lang=js"
import style0 from "./BubbleGame.vue?vue&type=style&index=0&id=bfab8a12&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bfab8a12",
  null
  
)

export default component.exports